import styled from 'styled-components';

export const Title = styled.h6`
  font-weight: bold;
`;

export const TextContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const WrapperInputAmount = styled.div`
  & .MuiFormControl-root {
    overflow: visible;
    border-radius: 4px;
  }
`;